<template>
  <v-dialog
    v-model="visible"
    persistent
    width="800"
    content-class="purchase-order-add-dialog"
    @click:outside="close"
  >
    <v-card v-if="dialogReady" rounded="0" class="purchase-order-add-dialog__card">
                <v-overlay :value="loading" absolute>
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <v-toolbar color="primary" class="white--text" flat>
                    <v-toolbar-title class="font-weight-bold">{{ isKenyaClient ? $t('memberDataSection.cherryCollection') : $t('memberDataSection.purchaseOrder') }}</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-btn icon class="white--text" @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-form
                    autocomplete="off"
                    ref="purchaseOrderForm"
                    class="purchase-order-add-dialog__form"
                    @submit.prevent="openConfirmDialog"
                    v-model="valid"
                >
                    <v-card-text class="black--text purchase-order-add-dialog__body">
                        <v-row class="mb-3">
                            <v-col cols="6" class="py-0 px-4">
                                <label>{{ $t('memberDataSection.purchaseDate') }}<span
                                        class="red--text">*</span></label>
                                <v-menu v-model="purchaseDateMenu" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="purchaseOrder.purchasedAt" append-icon="mdi-calendar"
                                            outlined dense readonly v-bind="attrs" v-on="on"
                                            v-on:click:append="purchaseDateMenu = true" :rules="purchaseOrderRules.purchaseDate"
                                            :placeholder="$t('memberDataSection.pOrder.selectDate')"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="purchaseOrder.purchasedAt" placeholder="Select Date"
                                        @input="purchaseDateMenu = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="6" class="py-0 px-4">
                                <label>{{ $t('memberDataSection.selectFarmer') }}<span
                                        class="red--text">*</span></label>
                                <v-select @input="onFarmerSelect()" v-model="purchaseOrder.farmerId" :items="farmers" outlined dense :rules="purchaseOrderRules.farmer" item-value="id" :item-text="getFieldText"
                                    :placeholder="$t('memberDataSection.pOrder.makeSelection')">
                                </v-select>
                            </v-col>
                            <v-col cols="6" class="py-0 px-4">
                                <label>{{ $t('memberDataSection.selectFarm') }}</label>
                                <v-select v-model="purchaseOrder.farmId" :items="farms" outlined dense item-value="id" item-text="farmName" :loading="loading"
                                    :placeholder="$t('memberDataSection.pOrder.makeSelection')">
                                </v-select>
                            </v-col>
                            <v-col cols="6" class="py-0 px-4">
                                <label>{{ $t('memberDataSection.selectPlantation') }}</label>
                                <v-select v-model="purchaseOrder.plantationId" :items="plantation" item-text="plantation_name" item-value="id" outlined dense :loading="loading"
                                    :placeholder="$t('memberDataSection.pOrder.makeSelection')">
                                </v-select>
                            </v-col>
                            <v-col cols="6" class="py-0 px-4">
                                <label>{{ $t('memberDataSection.coffeeSpecies') }}</label>
                                <v-select v-model="purchaseOrder.speciesId" :items="coffeeSpecies" @change="getCoffeeVariety" outlined dense item-value="id" item-text="name"
                                    :placeholder="$t('memberDataSection.pOrder.makeSelection')">
                                </v-select>
                            </v-col>
                            <v-col cols="6" class="py-0 px-4">
                                <label>{{ $t('memberDataSection.coffeeVariety') }}</label>
                                <v-select v-model="purchaseOrder.varietyId" :items="coffeeVariety" outlined dense item-value="id" item-text="name" :loading="loading"
                                    :placeholder="$t('memberDataSection.pOrder.makeSelection')">
                                </v-select>
                            </v-col>
                            <v-col cols="6" class="py-0 px-4">
                                <label>{{ $t('memberDataSection.coffeeType') }}</label>
                                <v-select
                                    v-model="purchaseOrder.coffeeTypeId"
                                    :items="coffeeTypes"
                                    outlined
                                    dense
                                    item-value="id"
                                    item-text="name"
                                    :placeholder="$t('memberDataSection.pOrder.makeSelection')"
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="6" class="py-0 px-4">
                                <div class="d-flex justify-space-between align-end">
                                    <label>{{ $t('memberDataSection.coffeeCherryQuantity') }}<span
                                            class="red--text">*</span></label>
                                    <label>KG</label>
                                </div>

                                <v-text-field type="number" outlined dense v-model="purchaseOrder.coffeeCherryQty" :rules="purchaseOrderRules.coffeeCherryQnt"
                                    :placeholder="$t('memberDataSection.pOrder.coffeeType')">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" class="py-0 px-4">
                                <label>{{ $t('memberDataSection.coffeeCherryQuality') }}<span
                                        class="red--text">*</span></label>
                                <v-select v-model="purchaseOrder.coffeeCherryQlty" :items="coffeeCherryQuality" outlined dense :rules="purchaseOrderRules.coffeeCherryQlty"
                                    item-text="name" item-value="name" :placeholder="$t('memberDataSection.pOrder.makeSelection')">
                                </v-select>
                            </v-col>
                            <v-col v-if="!isKenyaClient" cols="6" class="py-0 px-4">
                                <label>{{ $t('memberDataSection.pricePerKg') }}<span class="red--text">*</span></label>

                                <v-text-field type="number" outlined dense v-model="purchaseOrder.perKgPrice" :rules="purchaseOrderRules.perKgPrice"
                                    :placeholder="$t('memberDataSection.pOrder.enterPrice')">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" class="py-0 px-4">
                                <v-row v-if="isPhotoUploading" align="center" justify="center" class="mb-2">
                                    <v-col cols="12" class="text-center py-0">
                                        <p class="mb-1">{{ $t('activationKey.pleaseWait') }}</p>
                                        <v-progress-linear :value="uploadPercentage" height="7" color="primary" />
                                        <p class="mb-0">{{ uploadPercentage }}%</p>
                                    </v-col>
                                </v-row>
                                <v-card
                                    outlined
                                    class="upload-card d-flex align-center justify-center pa-4"
                                    style="position: relative;"
                                >
                                    <div class="text-center">
                                        <template v-if="uploadedFileUrl">
                                            <img
                                                :src="uploadedFileUrl"
                                                alt="Uploaded Image"
                                                class="upload-card__preview"
                                            />
                                            <v-btn
                                                icon
                                                color="white"
                                                class="upload-card__action upload-card__action--edit"
                                                @click="editImage"
                                            >
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                            <v-btn
                                                icon
                                                color="white"
                                                class="upload-card__action upload-card__action--delete"
                                                @click="deleteImage"
                                            >
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </template>
                                        <template v-else>
                                            <div class="upload-card__empty">
                                                <img
                                                    src="/img/camera.svg"
                                                    alt="Camera Logo"
                                                    class="upload-card__camera"
                                                />
                                                <input
                                                    type="file"
                                                    ref="fileInput"
                                                    accept="image/*"
                                                    style="display: none"
                                                    @change="handleFileUpload"
                                                />
                                                <v-btn
                                                    class="upload-card__add-btn"
                                                    height="44"
                                                    width="auto"
                                                    depressed
                                                    color="primary"
                                                    :disabled="isPhotoUploading"
                                                    @click="triggerFileInput"
                                                >
                                                    {{ $t('blends.manageProducts.addImage') }}
                                                </v-btn>
                                            </div>
                                        </template>
                                    </div>
                                </v-card>
                            </v-col>

                        </v-row>
                    </v-card-text>
                    <div class="purchase-order-add-dialog__footer">
                        <v-divider></v-divider>
                        <div v-if="!isKenyaClient" class="pay-now-section my-4">
                            <div class="total-section">
                                <span class="total">
                                    USD {{ isNaN((Number(purchaseOrder.coffeeCherryQty) * Number(purchaseOrder.perKgPrice)).toFixed(2)) ? 0 :
                                    ((Number(purchaseOrder.coffeeCherryQty) * Number(purchaseOrder.perKgPrice)).toFixed(2))
                                    }}
                                </span>
                                <span class="total-title">
                                  {{ $t('memberDataSection.pOrder.grandTotal')}}
                                </span>
                            </div>
                        </div>
                        <v-card-actions class="purchase-order-add-dialog__actions pt-0 pb-4 px-4">
                            <v-spacer></v-spacer>
                            <v-btn class="" outlined color="primary" @click="close" width="112">
                                {{ $t('cancel') }}
                            </v-btn>
                            <v-btn
                                width="112"
                                color="primary"
                                type="submit"
                                class="btn-11 btn-22"
                                :disabled="isPhotoUploading"
                            >
                                {{ $t('submit') }}
                            </v-btn>
                        </v-card-actions>
                    </div>
                </v-form>

    </v-card>

    <PurchaseOrderConfirmDialog
      v-model="confirmVisible"
      :field-rows="confirmationFieldRows"
      :photo-url="uploadedFileUrl"
      :confirming="loading"
      @edit="closeConfirmDialog"
      @confirm="confirmPurchaseOrder"
      @quality-grade="openQualityGrading"
    />

    <PurchaseOrderQualityGradingDialog
      v-model="qualityGradingVisible"
      :total-quantity="qualityGradingTotalQuantity"
      :unit-size="qualityGradingUnitSize"
      :lots="qualityGradingLots"
      :quality-scores="gradingQualityScores"
      :labels="gradingLabels"
      :grade-options="gradingGradeOptions"
      @finish-grading="onQualityGradingFinished"
      @lots-changed="qualityGradingLots = $event"
    />
  </v-dialog>
</template>

<script>
import { isKenyaClient } from "@/utils";
import loading from "@/mixins/LoadingMixin";
import CoffeeService from "@/_services/CoffeeService.js";
import PlantationService from "@/_services/PlantationService.js";
import BuyingStationService from "@/_services/BuyingStationService";
import S3UploadService from "@/_services/S3UploadService";
import PurchaseOrderConfirmDialog from "./ConfirmDialog.vue";
import PurchaseOrderQualityGradingDialog from "./QualityGradingDialog.vue";
import moment from "moment";

const COFFEE_PURCHASE_ORDER_UPLOAD_FOLDER = "coffee_purchase_order";

const DEFAULT_GRADING_GRADE_OPTIONS = [
  { text: "A", value: "A" },
  { text: "AA", value: "AA" },
  { text: "B", value: "B" },
  { text: "C", value: "C" },
];

export default {
  name: "PurchaseOrderAddDialog",
  components: {
    PurchaseOrderConfirmDialog,
    PurchaseOrderQualityGradingDialog,
  },
  mixins: [loading],
  props: {
    value: { type: Boolean, default: false },
    record: { type: Object, default: null },
    mode: {
      type: String,
      default: "add",
      validator: (v) => ["add", "edit"].includes(v),
    },
    buyingStationId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      visible: this.value,
      confirmVisible: false,
      qualityGradingVisible: false,
      qualityGradingLots: [],
      gradingQualityScores: [],
      gradingLabels: [],
      gradingGradeOptions: [...DEFAULT_GRADING_GRADE_OPTIONS],
      valid: true,
      purchaseDateMenu: false,
      purchaseOrder: {},
            coffeeVariety: [],
            coffeeSpecies: [],
            coffeeTypes: [],
            coffeeCherryQuality: [],
            plantation: [],
            loading: false,
            farms: [],
            farmers: [],
            uploadedFileUrl: null,
            coffeeCherryPic: null,
            uploadPercentage: 0,
            isPhotoUploading: false,
            purchaseOrderRules: {
                purchaseDate: [
                    (v) => !!v || this.$t('memberDataSection.pOrder.reqPurchaseDate')
                ],
                farmer: [(v) => !!v || this.$t('memberDataSection.pOrder.reqFarmer')],
                coffeeCherryQnt: [(v) => !!v || this.$t('memberDataSection.pOrder.reqCoffeeQnty')],
                coffeeCherryQlty: [(v) => !!v || this.$t('memberDataSection.pOrder.reqCoffeeQnty')],
                perKgPrice: [(v) => isKenyaClient() || !!v || this.$t('memberDataSection.pOrder.reqPrice')],
            },
    };
  },
  computed: {
    isAddMode() {
      return this.mode === "add";
    },
    isKenyaClient() {
      return isKenyaClient();
    },
    dialogReady() {
      return this.isAddMode || Boolean(this.record);
    },
    getOrganizationId() {
            return this.$store.getters.getUser?.user_organization?.id;
        },
        getSubOrganizationId() {
            return this.$store.getters.getUser?.user_organization?.subOrganizationId;
        },
    isSubEnterprise() {
      return this.$store.getters.isSubEnterprise;
    },
    qualityGradingTotalQuantity() {
      return Number(this.purchaseOrder.coffeeCherryQty) || 0;
    },
    qualityGradingUnitSize() {
      const stored = this.purchaseOrder.qualityGradingUnitSize;
      if (stored != null && stored !== "") return stored;
      return 40;
    },
    confirmationFieldRows() {
      const t = (key) => this.$t(`memberDataSection.${key}`);
      const dash = "—";
      const qty =
        this.purchaseOrder.coffeeCherryQty != null &&
        this.purchaseOrder.coffeeCherryQty !== ""
          ? `${this.purchaseOrder.coffeeCherryQty} kg`
          : dash;

      return [
        [
          {
            key: "purchaseDate",
            label: t("purchaseDate"),
            value: this.formatConfirmationDate(this.purchaseOrder.purchasedAt),
          },
          { key: "farm", label: t("farm"), value: this.resolveFarmName() },
          {
            key: "plantation",
            label: t("plantation"),
            value: this.resolvePlantationName(),
          },
        ],
        [
          {
            key: "coffeeSpecies",
            label: t("coffeeSpecies"),
            value: this.resolveSpeciesName(),
          },
          {
            key: "coffeeVariety",
            label: t("coffeeVariety"),
            value: this.resolveVarietyName(),
          },
          {
            key: "coffeeType",
            label: t("coffeeType"),
            value: this.resolveCoffeeTypeName(),
          },
        ],
        [
          {
            key: "coffeeCherryQty",
            label: t("coffeeCherryQuantity"),
            value: qty,
          },
          {
            key: "coffeeCherryQlty",
            label: t("coffeeCherryQuality"),
            value: this.purchaseOrder.coffeeCherryQlty || dash,
          },
        ],
      ];
    },
  },
  watch: {
    value(v) {
      this.visible = v;
      if (v) {
        this.onOpen();
      }
    },
    visible(v) {
      this.$emit("input", v);
    },
    record: {
      immediate: true,
      handler(rec) {
        if (this.visible && rec && !this.isAddMode) {
          this.initFromRecord(rec);
        }
      },
    },
  },
  methods: {
    getFieldText(item) {
      return `${item.firstName} ${item?.lastName || ""} ${item?.userType === "offline" ? "(O)" : ""}`;
    },
    close() {
      this.confirmVisible = false;
      this.visible = false;
      this.$emit("close");
    },
    closeConfirmDialog() {
      this.confirmVisible = false;
    },
    openConfirmDialog() {
      if (!this.$refs.purchaseOrderForm.validate()) return;
      this.ensureBuyingStationId();
      this.confirmVisible = true;
    },
    async openQualityGrading() {
      await this.loadGradingOptions();
      this.qualityGradingVisible = true;
    },
    async loadGradingOptions() {
      try {
        const { data } = await this.$http.get("/coffee/greencoffee/options");
        const payload = data?.data || data || {};
        this.gradingQualityScores = payload.greenCoffeeQuality || [];
        this.gradingLabels = payload.labels || [];
        const grades = payload.gradeOptions || [];
        this.gradingGradeOptions = grades.length
          ? grades
          : [...DEFAULT_GRADING_GRADE_OPTIONS];
      } catch (err) {
        console.log("Purchase order grading options fetch error", err);
        if (!this.gradingQualityScores.length && this.coffeeCherryQuality.length) {
          this.gradingQualityScores = this.coffeeCherryQuality.map((item) => ({
            id: item.id,
            name: item.name,
          }));
        }
        if (!this.gradingGradeOptions.length) {
          this.gradingGradeOptions = [...DEFAULT_GRADING_GRADE_OPTIONS];
        }
      }
    },
    onQualityGradingFinished(lots) {
      this.qualityGradingLots = lots || [];
      this.purchaseOrder.qualityGradingLots = this.qualityGradingLots;
      this.$notify({
        type: "success",
        title: this.$t("memberDataSection.greenCoffee.finishGrading"),
        text: this.$t("memberDataSection.purchaseOrderDetail.qualityGradingFinished"),
      });
    },
    formatConfirmationDate(value) {
      if (!value) return "—";
      const parsed = moment(
        value,
        [moment.ISO_8601, "DD-MMM-YYYY", "DD-MMM-YY", "MM/DD/YYYY", "YYYY-MM-DD"],
        true
      );
      if (parsed.isValid()) {
        return parsed.format("DD-MMM-YYYY").toUpperCase();
      }
      const fallback = moment(value);
      return fallback.isValid() ? fallback.format("DD-MMM-YYYY").toUpperCase() : value;
    },
    resolveFarmName() {
      const farm = this.farms.find((f) => f.id === this.purchaseOrder.farmId);
      return farm?.farmName || "—";
    },
    resolvePlantationName() {
      const plantation = this.plantation.find(
        (p) => p.id === this.purchaseOrder.plantationId
      );
      return plantation?.plantation_name || "—";
    },
    resolveSpeciesName() {
      const species = this.coffeeSpecies.find(
        (s) => s.id === this.purchaseOrder.speciesId
      );
      return species?.name || "—";
    },
    resolveVarietyName() {
      const variety = this.coffeeVariety.find(
        (v) => v.id === this.purchaseOrder.varietyId
      );
      return variety?.name || "—";
    },
    resolveCoffeeTypeName() {
      const coffeeType = this.coffeeTypes.find(
        (t) => t.id === this.purchaseOrder.coffeeTypeId
      );
      return coffeeType?.name || "—";
    },
    async onOpen() {
      await this.loadReferenceData();
      if (this.isAddMode) {
        this.resetForAdd();
        return;
      }
      await this.initFromRecord(this.record);
    },
    resetForAdd() {
      const stationId = parseInt(this.buyingStationId, 10);
      this.purchaseOrder = {
        buyingStationId: Number.isNaN(stationId) ? null : stationId,
      };
      this.purchaseDateMenu = false;
      this.farms = [];
      this.plantation = [];
      this.coffeeVariety = [];
      this.confirmVisible = false;
      this.qualityGradingLots = [];
      this.clearPhotoState();
      if (this.$refs.purchaseOrderForm) {
        this.$refs.purchaseOrderForm.resetValidation();
      }
    },
    clearPhotoState() {
      this.uploadedFileUrl = null;
      this.coffeeCherryPic = null;
      this.uploadPercentage = 0;
      this.isPhotoUploading = false;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
    resolvePhotoUrl(item) {
      if (!item) return null;
      if (typeof item === "string") return item;
      return item.file_name || item.location || item.s3_key || null;
    },
    initPhotoFromOrder(pic) {
      if (!pic) {
        this.clearPhotoState();
        return;
      }
      const item = Array.isArray(pic) ? pic[0] : pic;
      this.uploadedFileUrl = this.resolvePhotoUrl(item);
      const s3Key = item?.s3_key;
      this.coffeeCherryPic = s3Key ? { s3_key: s3Key } : null;
    },
    buildSubmitPayload() {
      const payload = {
        farmerId: this.purchaseOrder.farmerId,
        buyingStationId: this.purchaseOrder.buyingStationId,
        farmId: this.purchaseOrder.farmId,
        plantationId: this.purchaseOrder.plantationId,
        speciesId: this.purchaseOrder.speciesId,
        varietyId: this.purchaseOrder.varietyId,
        coffeeTypeId: this.purchaseOrder.coffeeTypeId,
        coffeeCherryQty: this.purchaseOrder.coffeeCherryQty,
        coffeeCherryQlty: this.purchaseOrder.coffeeCherryQlty,
        perKgPrice: this.purchaseOrder.perKgPrice,
        grandTotal:
          parseInt(this.purchaseOrder.coffeeCherryQty, 10) *
          parseInt(this.purchaseOrder.perKgPrice, 10),
        isPaid: "1",
        purchasedAt: this.purchaseOrder.purchasedAt
          ? moment(this.purchaseOrder.purchasedAt).format("MM/DD/YYYY")
          : null,
      };
      if (this.coffeeCherryPic?.s3_key) {
        payload.coffeeCherryPic = this.coffeeCherryPic;
      }
      return payload;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    editImage() {
      this.uploadedFileUrl = null;
      this.coffeeCherryPic = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
    deleteImage() {
      this.clearPhotoState();
    },
    async handleFileUpload(event) {
      const file = event.target.files[0];
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
      if (!file) return;
      if (!allowedTypes.includes(file.type)) {
        this.$notify({
          title: this.$t("blends.manageProducts.fileUploadFailed"),
          text: this.$t("blends.manageProducts.unsupportedFileFormat"),
          type: "error",
        });
        return;
      }
      this.isPhotoUploading = true;
      this.uploadPercentage = 0;
      try {
        const result = await S3UploadService.imageUpload(
          file,
          COFFEE_PURCHASE_ORDER_UPLOAD_FOLDER,
          (progress) => {
            this.uploadPercentage = progress;
          }
        );
        this.uploadedFileUrl = result.fullPath;
        this.coffeeCherryPic = { s3_key: result.key };
      } catch (err) {
        this.$notify({
          title: this.$t("blends.manageProducts.fileUploadFailed"),
          text: err?.message || this.$t("blends.manageProducts.errorUploadingFile"),
          type: "error",
        });
      } finally {
        this.isPhotoUploading = false;
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }
      }
    },
    ensureBuyingStationId() {
      if (this.purchaseOrder.buyingStationId) return;
      const stationId = this.buyingStationId || this.record?.buyingStationId;
      if (stationId != null && stationId !== "") {
        this.purchaseOrder.buyingStationId = parseInt(stationId, 10);
      }
    },
    async initFromRecord(record) {
      const orderId = record?.id || record?.orderCode;
      if (!orderId) return;
      await this.getPurchaseOrder(orderId);
    },
    async loadReferenceData() {
      this.startLoading();
      try {
        await Promise.all([
          this.getFarmers(),
          this.getCoffeeSpecies(),
          this.getCoffeeTypes(),
          this.getCoffeeCherryQuality(),
        ]);
      } finally {
        this.stopLoading();
      }
    },
    async confirmPurchaseOrder() {
      this.startLoading();
      try {
        if (this.purchaseOrder.id) {
                    const { data } = await this.$http.put("coffee/buying-station/purchase-order", {
                        orderId: this.purchaseOrder.id,
                        ...this.buildSubmitPayload(),
                    })
                    if (data && data.code === 200) {
                        this.$notify({
                            title: "Purchase Order Initiated successfully.",
                            type: "success",
                        });
                    }
                } else {
                    const { data } = await this.$http.post("coffee/buying-station/purchase-order", this.buildSubmitPayload())
                    if (data && data.code === 200) {
                        this.$notify({
                            title: "Purchase Order Initiated successfully.",
                            type: "success",
                        });
                    }
        }
        this.confirmVisible = false;
        this.$emit("save");
        this.visible = false;
        this.$emit("close");
      } catch (err) {
        this.$notify({
          type: "error",
          text: err?.data?.message || err?.message || this.$t("error"),
        });
      }
      this.stopLoading();
    },
        async getCoffeeVariety() {
            this.startLoading();
            try {
                const d = await CoffeeService.getMemberDataCoffeeVariety({ page: 1, itemsPerPage: 100, sortBy: [], coffeeSpecies: this.purchaseOrder.speciesId })
                if (d.code === 200) {
                    this.coffeeVariety = d.data.rows;
                }
            } catch (err) {
                console.log('e', err)
            } finally {
                this.stopLoading();
            }
        },
        async getCoffeeSpecies() {
            try {
                const d = await CoffeeService.getMemberDataCoffeeSpecies({ page: 1, itemsPerPage: 100, sortBy: [] })
                if (d.code === 200) {
                    const seen = new Set();
                    this.coffeeSpecies = d.data.rows.filter(item => {
                      const duplicate = seen.has(item.name);
                      seen.add(item.name);
                      return !duplicate;
                    });
                    
                }
            } catch (err) {
                console.log('e', err)
            }
        },
        async getCoffeeTypes() {
            try {
                const res = await CoffeeService.getCoffeeTypes();
                if (res.code === 200) {
                    this.coffeeTypes = res.data;
                }
            } catch (err) {
                console.log('Coffee Types FETCH Error', err);
            }
        },
        async getCoffeeCherryQuality() {
            try {
                const d = await CoffeeService.getTreeData(
                    'coffeeCherryQuality',
                    this.getOrganizationId,
                    this.isSubEnterprise ? this.getSubOrganizationId : null
                );
                if (d.code === 200) {
                    const payload = d.data || {};
                    this.coffeeCherryQuality =
                        payload.rows ||
                        (Array.isArray(payload) ? payload : []);
                }
            } catch (err) {
                console.log('Coffee Cherry Quality FETCH Error', err);
                this.coffeeCherryQuality = [];
            }
        },
        async getPlantation() {
            try {
                const data = await PlantationService.getPlantationData({ page: 1, itemsPerPage: 100, sortBy: [] }, '', '', this.purchaseOrder.farmerId)
                if (data.code === 200) {
                    this.plantation = data.data.response;
                }
            } catch (err) {
                console.log('e', err)
            }
        },
        async getFarms() {
            try {
                const data = await BuyingStationService.getFarms(this.purchaseOrder.farmerId)
                if (data.code === 200) {
                    this.farms = data.data.info;
                }
            } catch (err) {
                console.log('e', err)
            }
        },
        async getFarmers() {
            try {
                await this.$store.dispatch('farmers/fetchFarmersCached', { page: 1, limit: 1000 });
                this.farmers = this.$store.getters['farmers/farmersList'];
            } catch (err) {
                console.log('e', err)
            }
        },
        async getPurchaseOrder(id) {
            this.startLoading();
            try {
                // Ensure coffee cherry quality is loaded before fetching purchase order
                if (this.coffeeCherryQuality.length === 0) {
                    await this.getCoffeeCherryQuality();
                }
                
                const data = await BuyingStationService.getPurchaseOrder(id)
                if (data.code === 200) {
                    this.purchaseOrder = data.data
                    this.purchaseOrder.purchasedAt = data.data.purchasedAt ? moment(data.data.purchasedAt).format('DD-MMM-YYYY') : ''
                    this.initPhotoFromOrder(data.data.coffeeCherryPic)
                    this.qualityGradingLots = Array.isArray(data.data.qualityGradingLots)
                      ? [...data.data.qualityGradingLots]
                      : []

                    // Verify coffeeCherryQlty value exists in the options
                    if (this.purchaseOrder.farmerId) {
                        await this.getFarms();
                        await this.getPlantation();
                    }

                    if (this.purchaseOrder.speciesId) {
                        await this.getCoffeeVariety();
                    }
                }
            } catch (error) {
                console.log('e', error)
            } finally {
                this.stopLoading();
            }
        },
        async onFarmerSelect() {
            this.startLoading();
            await this.getFarms();
            await this.getPlantation();
            this.stopLoading();
        },
  },
};
</script>
<style>
.purchase-order-add-dialog {
  overflow: visible;
}

.purchase-order-add-dialog__card {
  display: flex;
  flex-direction: column;
  min-height: 85vh;
  max-height: 90vh;
  background: #ffffff !important;
  overflow: hidden;
  position: relative;
}

/* Header is a fixed-height flex item — without this it stretches vertically to
   fill the card's min-height, elongating the brown title bar. */
.purchase-order-add-dialog__card > .v-toolbar {
  flex: 0 0 auto;
}

.purchase-order-add-dialog__form {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  background: #ffffff;
}

.purchase-order-add-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  background: #ffffff !important;
  -webkit-overflow-scrolling: touch;
}

.purchase-order-add-dialog__footer {
  flex: 0 0 auto;
  background: #ffffff !important;
  padding: 0 8px;
}

.purchase-order-add-dialog__actions {
  background: #ffffff !important;
}

.pay-now-section {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.total-section {
    display: flex;
    flex-flow: column;
    margin-left: 25px;
}

.total {
    font-weight: 400;
    font-size: 32px;
    line-height: 38px;
    text-align: right;
    color: #3E3E3E;
    transform: rotate(0.26deg);
}

.total-title {
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    text-align: right;
    color: #3E3E3E;
    transform: rotate(0.26deg);
}

.upload-card {
    width: 100%;
    min-height: 150px;
    border: 1px dashed #cccccc;
    border-radius: 8px;
    text-align: center;
}

.upload-card__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.upload-card__camera {
    display: block;
    width: auto;
    height: auto;
}

.upload-card__add-btn {
    margin-top: 20px;
}

.upload-card__preview {
    width: 100%;
    max-height: 200px;
    object-fit: cover;
    border-radius: 8px;
}

.upload-card__action {
    position: absolute;
    top: 8px;
}

.upload-card__action--edit {
    right: 48px;
    background-color: #00BD73 !important;
}

.upload-card__action--delete {
    right: 8px;
    background-color: #f44336 !important;
}
</style>